import { render, staticRenderFns } from "./userAssignment.vue?vue&type=template&id=023d237c&scoped=true&"
import script from "./userAssignment.vue?vue&type=script&lang=js&"
export * from "./userAssignment.vue?vue&type=script&lang=js&"
import style0 from "./userAssignment.vue?vue&type=style&index=0&id=023d237c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d237c",
  null
  
)

export default component.exports